import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { GroupedInformationSemantic_getInstance10la8ntbgzaf6 as GroupedInformationSemantic_getInstance } from '../theming/appTheme.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  bodyBold2czwdzwknab0k as bodyBold,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { validatedmmpm5lnzq3lm as validated } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  validategsg6go7eyi9d as validate,
  assertValidEmail3utsnuo6xdy4w as assertValidEmail,
} from '../../utils/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import {
  errorTextv58wi1t0me7u as errorText,
  icon1sxjaie5w1apt as icon,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  timesx4ey3un7ihw1 as times,
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../utils/utils.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../theming/separators.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { EmailAddress1n0o8cqqfp9qz as EmailAddress } from '../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { downloadBlob3lmzpxtmphn66 as downloadBlob } from '../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { closePopovers89geeulkriez as closePopovers } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function emailDocumentDialog(_this__u8e3s4, title_0, withEmail) {
  title_0 = title_0 === VOID ? 'Email Document' : title_0;
  var tmp = get_dialogStack();
  tmp.vh2(VOID, VOID, ($this$dialog, close) => {
    var tmp = $this$dialog.kbb(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(30)), $this$dialog.jbb(GroupedInformationSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$dialog.pc());
    var tmp0_elvis_lhs = $this$dialog.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
    $this$dialog.gbb(p, view);
    view.zbm(true);
    title(view, title_0);
    var email = validated(mutableRemember(VOID, VOID, emailDocumentDialog$lambda$lambda));
    // Inline function 'com.crowpay.views.components.field2' call
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(true);
    view_0.bb9(get_AppDimensions().pg2_1);
    bodyBold(view_0, 'Send To');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_0 = view_0.jbb(FieldSemantic_getInstance());
    var tmp_1 = validate(view_0, email);
    // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextInput())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    var value = 'me@email.com';
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    view_1.vb5_1.bb4_1.kb7_1.placeholder = value;
    view_1.zah(view_1.icn_1, assertValidEmail(email));
    view_0.hbb(p_1, view_1);
    view_0.lbb(tmp_1, view_1);
    var tmp$ret$6 = issueText(view_0, get_issues(email));
    view_0.lbb(tmp_0, tmp$ret$6);
    view_0.lbb(view_0.jbb(SubtextSemantic_getInstance()), errorText(view_0));
    view.hbb(p_0, view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_2 = view.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.gbb(p_2, view_2);
    view_2.zbm(false);
    view_2.bb9(get_AppDimensions().kg2_1);
    var tmp_2 = get_primaryButton(view_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.gbb(p_3, view_3);
    var tmp_3 = KMutableProperty0();
    var tmp_4 = Button$_get_enabled_$ref_61t7nx(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      var tmp$ret$12 = $this$reactiveScope.daj(get_issues(email)).i1();
      this_0.set(tmp$ret$12);
      return Unit_instance;
    });
    specCenteredText(view_3, 'Send Email');
    onClick(view_3, VOID, VOID, emailDocumentDialog$lambda$slambda_0(withEmail, email, close));
    view_2.hbb(p_3, view_3);
    view_2.lbb(tmp_2, view_3);
    var tmp_5 = get_textButton(view_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (Button())(view_2.pc());
    var tmp0_elvis_lhs_4 = view_2.ebb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
    view_2.gbb(p_4, view_4);
    specCenteredText(view_4, 'Go Back');
    onClick(view_4, VOID, VOID, emailDocumentDialog$lambda$slambda_2(close));
    view_2.hbb(p_4, view_4);
    view_2.lbb(tmp_5, view_4);
    view.hbb(p_2, view_2);
    $this$dialog.hbb(p, view);
    return $this$dialog.lbb(tmp, view);
  });
}
function exportCrowPayLegalDocument(_this__u8e3s4, document, size) {
  size = size === VOID ? times(get_AppDimensions().ug1_1, 1.1) : size;
  var tmp = _this__u8e3s4.kbb(get_tertiaryButton(_this__u8e3s4), get_compact(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (MenuButton())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.ac4_1 = true;
  view.dc4(Companion_getInstance().acr_1);
  view.lbb(get_centered(view), icon(view, resize(Companion_getInstance_0().jcg_1, size), 'export'));
  view.gc4(($this$opensMenu) => {
    var tmp = get_compact($this$opensMenu);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$opensMenu.pc());
    var tmp0_elvis_lhs = $this$opensMenu.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
    $this$opensMenu.gbb(p, view);
    view.zbm(true);
    view.bb9(get_px(0));
    var tmp_0 = Companion_getInstance_0().jcg_1;
    exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option_v5poc9(view, tmp_0, 'Download', exportCrowPayLegalDocument$lambda$slambda_0(view, document));
    greySeparator(view);
    var tmp_1 = Companion_getInstance_0().ycg_1;
    exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option_v5poc9(view, tmp_1, 'Email', exportCrowPayLegalDocument$lambda$slambda_2(view, document));
    $this$opensMenu.hbb(p, view);
    $this$opensMenu.lbb(tmp, view);
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option_v5poc9($this_col, icon_0, name, action) {
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())($this_col.pc());
  var tmp0_elvis_lhs = $this_col.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this_col : tmp0_elvis_lhs;
  $this_col.gbb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  var tmp = get_centered(view_0);
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = name.toLowerCase();
  view_0.lbb(tmp, icon(view_0, icon_0, tmp$ret$1));
  view_0.lbb(get_centered(view_0), body(view_0, name));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_0.hbb(p_1, view_1);
  view.hbb(p_0, view_0);
  onClick(view, name, VOID, exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option$slambda_s1grtp_0(action));
  $this_col.hbb(p, view);
}
function emailDocumentDialog$lambda$lambda($this$mutableRemember) {
  return new (EmailAddress())($this$mutableRemember.daj($this$mutableRemember.daj(get_session()).rfw_1).e88_1);
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fin_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp.a3n_1;
  var tmp_0 = $this.ein_1(new (EmailAddress())(tmp$ret$0), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.gin_1();
  return Unit_instance;
}
var emailDocumentDialog$lambda$slambdaClass;
function emailDocumentDialog$lambda$slambda() {
  if (emailDocumentDialog$lambda$slambdaClass === VOID) {
    class $ {
      constructor($withEmail, $email, $close) {
        this.ein_1 = $withEmail;
        this.fin_1 = $email;
        this.gin_1 = $close;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    emailDocumentDialog$lambda$slambdaClass = $;
  }
  return emailDocumentDialog$lambda$slambdaClass;
}
function emailDocumentDialog$lambda$slambda_0($withEmail, $email, $close) {
  var i = new (emailDocumentDialog$lambda$slambda())($withEmail, $email, $close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var emailDocumentDialog$lambda$slambdaClass_0;
function emailDocumentDialog$lambda$slambda_1() {
  if (emailDocumentDialog$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($close) {
        this.hin_1 = $close;
      }
      uao($completion) {
        this.hin_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    emailDocumentDialog$lambda$slambdaClass_0 = $;
  }
  return emailDocumentDialog$lambda$slambdaClass_0;
}
function emailDocumentDialog$lambda$slambda_2($close) {
  var i = new (emailDocumentDialog$lambda$slambda_1())($close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.iin_1.pc();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.jin_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  var tmp_1 = downloadBlob(tmp, 'Stoze_Contractor_Terms_and_Conditions.html', toBlob(tmp$ret$0.b5v_1, 'text/html'), VOID, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  closePopovers($this.iin_1);
  return Unit_instance;
}
var exportCrowPayLegalDocument$lambda$slambdaClass;
function exportCrowPayLegalDocument$lambda$slambda() {
  if (exportCrowPayLegalDocument$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$col, $document) {
        this.iin_1 = $$this$col;
        this.jin_1 = $document;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    exportCrowPayLegalDocument$lambda$slambdaClass = $;
  }
  return exportCrowPayLegalDocument$lambda$slambdaClass;
}
function exportCrowPayLegalDocument$lambda$slambda_0($$this$col, $document) {
  var i = new (exportCrowPayLegalDocument$lambda$slambda())($$this$col, $document);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, email, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().rff_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.kin_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = tmp_0.lfj(tmp$ret$1.y5u_1, email, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var exportCrowPayLegalDocument$lambda$slambda$slambdaClass;
function exportCrowPayLegalDocument$lambda$slambda$slambda() {
  if (exportCrowPayLegalDocument$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($document) {
        this.kin_1 = $document;
      }
      lin(email, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, email), $completion);
      }
      s2(p1, $completion) {
        return this.lin(p1 instanceof EmailAddress() ? p1.a3n_1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    exportCrowPayLegalDocument$lambda$slambda$slambdaClass = $;
  }
  return exportCrowPayLegalDocument$lambda$slambda$slambdaClass;
}
function exportCrowPayLegalDocument$lambda$slambda$slambda_0($document) {
  var i = new (exportCrowPayLegalDocument$lambda$slambda$slambda())($document);
  var l = (email, $completion) => i.lin(email.a3n_1, $completion);
  l.$arity = 1;
  return l;
}
var exportCrowPayLegalDocument$lambda$slambdaClass_0;
function exportCrowPayLegalDocument$lambda$slambda_1() {
  if (exportCrowPayLegalDocument$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$col, $document) {
        this.min_1 = $$this$col;
        this.nin_1 = $document;
      }
      uao($completion) {
        emailDocumentDialog(this.min_1, VOID, exportCrowPayLegalDocument$lambda$slambda$slambda_0(this.nin_1));
        closePopovers(this.min_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    exportCrowPayLegalDocument$lambda$slambdaClass_0 = $;
  }
  return exportCrowPayLegalDocument$lambda$slambdaClass_0;
}
function exportCrowPayLegalDocument$lambda$slambda_2($$this$col, $document) {
  var i = new (exportCrowPayLegalDocument$lambda$slambda_1())($$this$col, $document);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.oin_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option$slambda_s1grtpClass;
function exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option$slambda_s1grtp() {
  if (exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option$slambda_s1grtpClass === VOID) {
    class $ {
      constructor($action) {
        this.oin_1 = $action;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option$slambda_s1grtpClass = $;
  }
  return exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option$slambda_s1grtpClass;
}
function exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option$slambda_s1grtp_0($action) {
  var i = new (exportCrowPayLegalDocument$_anonymous_$_anonymous_$_anonymous_$option$slambda_s1grtp())($action);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  exportCrowPayLegalDocument as exportCrowPayLegalDocument31qdjr0k7gqoi,
};
//endregion

//# sourceMappingURL=emailDocumentDialog.mjs.map
